module.exports = __webpack_public_path__ + "img/wings.8b5815f9.svg";